import {
  ISchoolClassProps,
  ISchoolClassCreateParams,
  ISchoolClassUpdateParams,
  ISchoolClassBaseProps,
  ISchoolClassSimpleProps,
} from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/schoolclass';

export const createSchoolClassAsync = async ({
  data,
}: ISchoolClassCreateParams): Promise<ISchoolClassProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSchoolClassByIdAsync = async (
  id: number,
): Promise<ISchoolClassProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSchoolClassByLicenseAsync = async (): Promise<
  ISchoolClassSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSchoolClassAsync = async ({
  id,
  data,
}: ISchoolClassUpdateParams): Promise<ISchoolClassProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSchoolClassAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
